import { useMemo } from 'react'
import { usePeople } from './usePeople'
import { buildFamilyTreeText } from '../utils/buildFamilyTreeText'

export function useFamilyTree(user, familyId) {
  const { people, loading, ...peopleActions } = usePeople(user, familyId)

  const text = useMemo(() => {
    if (loading || !people.length) return ''
    return buildFamilyTreeText(people)
  }, [people]) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    people,
    text,
    loading,
    ...peopleActions,
  }
}
